import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { TopActiveChannel } from '@src/api/types/activeChannel';
import { TopActiveParticipant } from '@src/api/types/activeParticipant';
import {
  AvailableDateRange,
  DashboardSummary,
  Period,
  PeriodRequest,
  ViewByRequest,
} from '@src/api/types/communityDashboard';

export type CommunityDashboardResponse = {
  period: Period;
  available_date_range: AvailableDateRange;
  view_by: string;
  summary: DashboardSummary;
  graph_labels: string[];
  validation_messages?: string[];
  top_participants: TopActiveParticipant[];
  top_channels: TopActiveChannel[];
};

export type CommunityDashboardRequest = {
  period: PeriodRequest;
  view_by: ViewByRequest;
  start_date: string | null;
  end_date: string | null;
};

export const communityDashboardApiClient = {
  index: async (
    params: CommunityDashboardRequest,
  ): Promise<ApiResult<CommunityDashboardResponse>> => {
    return await axiosClient.get('/tenant/dashboard', { params });
  },
};
